/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  
  async fetchWallets() {
    let response = await apiCall("banking/walletconf/list_wallets", {});
    return response;
  },
  
  async fetchWalletStats(){
    return await apiCall("banking/walletconf/stats", {});
  }
};
